import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-pagination-controls',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './pagination-controls.component.html',
    styleUrls: ['./pagination-controls.component.scss'],
    standalone: false
})
export class DsPaginationControlsComponent implements OnChanges, OnInit {

  @Input() currentPage: number = 1;
  @Input() itemsPerPage: number = 20;
  @Input() itemsCount: number = 20;
  @Input() rightNavigation?: boolean = true;
  @Output() onChangePage = new EventEmitter<number>();

  public pagesCount: number = 1;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['itemsCount']) {
      this.pagesCount = Math.ceil(changes['itemsCount'].currentValue / this.itemsPerPage);
    }
  }

  ngOnInit() {
    this.pagesCount = Math.ceil(this.itemsCount / this.itemsPerPage);
  }

  public changePage(event: any, page: number): void {
    event.preventDefault();
    if (page === this.currentPage) {
      return;
    }
    this.currentPage = page;
    this.onChangePage.emit(page);
  }

}
